import { render, staticRenderFns } from "./MessageNode.vue?vue&type=template&id=3d706616&scoped=true&"
import script from "./MessageNode.vue?vue&type=script&lang=js&"
export * from "./MessageNode.vue?vue&type=script&lang=js&"
import style0 from "./MessageNode.vue?vue&type=style&index=0&id=3d706616&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d706616",
  null
  
)

export default component.exports